import { isPlatformBrowser } from '@angular/common';
import { HttpEventType } from '@angular/common/http';
import { Component, Inject, Optional, PLATFORM_ID } from '@angular/core';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import readXlsxFile from 'read-excel-file';
import { firstValueFrom } from 'rxjs';
import { ModalObjectType } from 'src/app/interfaces/modal-object-types.interface';
import { SellerImportModel } from 'src/app/models/imports/seller-import-model';
import { LoadPreInvoicingModel } from 'src/app/models/invoicing/load-preinvoicing.models';
import { PreInvoicingAlertModel } from 'src/app/models/invoicing/pre-invoicing-alert.models';
import { SellerService } from 'src/app/services/archive/seller.service';
import { ToastHandlerService } from 'src/app/services/toast/toast-handler.service';

@Component({
  selector: 'app-import-seller',
  templateUrl: './import-seller.component.html',
  styleUrls: ['./import-seller.component.scss'],
  standalone: false
})
export class ImportSellerComponent {

  eventFile: any;
  errorSeller: number = 0;
  loadPreInvoicingModel: LoadPreInvoicingModel = new LoadPreInvoicingModel();
  nameFile: string = '';
  sellerAlerts: Array<PreInvoicingAlertModel> = new Array<PreInvoicingAlertModel>;
  sellerImport: boolean = false;
  visibleTxt: boolean = false;

  constructor(
    private sellerService: SellerService,
    public config: DynamicDialogConfig,
    private toastHandlerService: ToastHandlerService,
    @Optional() private ref: DynamicDialogRef,
    @Inject(PLATFORM_ID) private platformId: object) { }

  attachFileImport() {
    //validación para ejecutar el código cuando la platafoma de uso sea un navegador
    if (isPlatformBrowser(this.platformId)) {
      document.getElementById('fileImport')?.click();
    }
  }

  clearInputFile() {
    this.nameFile = 'Ningún archivo seleccionado.';
    if (this.eventFile) {
      if (isPlatformBrowser(this.platformId)) {
        this.eventFile.target.value = '';
      }
    }
  }

  close() {
    const data: ModalObjectType = {};
    if (this.sellerImport) {
      data.params = { reload: true };
      this.ref.close(data);
    } else {
      data.params = { reload: false };
      this.ref.close(data);
    }
  }

  getNameFile(file: any) {
    this.eventFile = file;
    const files = this.eventFile.target.files;
    if (files.length != 0) {
      for (let i = 0; i < files.length; i++) {
        this.nameFile = files[i].name;
      }
    } else {
      this.nameFile = 'Ningún archivo seleccionado.';
    }
  }

  downloadGuideImport() {
    this.sellerService.downloadGuideImport().subscribe(data => {
      switch (data.type) {
        case HttpEventType.Response: {
          const downloadedFile = new Blob([data.body!], { type: data.body!.type });
          const a = document.createElement('a');
          a.setAttribute('style', 'display:none;');
          document.body.appendChild(a);
          a.download = "GuiaVendedores.docx";
          a.href = URL.createObjectURL(downloadedFile);
          a.target = '_blank';
          a.click();
          document.body.removeChild(a);
          break;
        }
      }
    });
  }

  downloadErrorsTxt() {
    if (!this.sellerAlerts || this.sellerAlerts.length === 0) {
      this.toastHandlerService.showToast(
        'error',
        'No hay alertas para exportar'
      );
      return;
    }

    this.sellerService.exportImportErrors(this.sellerAlerts).subscribe({
      next: (blob: Blob) => {
        const file = new Blob([blob], { type: 'text/plain' });
        const url = window.URL.createObjectURL(file);
        const today = new Date();
        const formatDate = today.toISOString().split('T')[0];

        const a = document.createElement('a');
        a.href = url;
        a.download = `ErroresImportacionVendedores_${formatDate}.txt`;
        a.click();

        window.URL.revokeObjectURL(url);
      },
      error: () => {
        this.toastHandlerService.showToast(
          'error',
          'Error al exportar el archivo'
        );
      }
    });
  }

  importSellers() {
    this.sellerAlerts = [];
    this.errorSeller = 0;
    this.visibleTxt = false;
    //validación para ejecutar el código cuando la platafoma de uso sea un navegador
    if (!isPlatformBrowser(this.platformId)) return;
    let isOk: boolean = true;
    const input = document.getElementById("fileImport") as any;
    const rowsImports = new Array<SellerImportModel>();
    let row: SellerImportModel;
    let counter: number = 1, branchCode: number, typeDocumentId: number, documents: string, digitVerification: number, name: string,
      position: string, phone: string, alterPhone: string | null, email: string, address: string, cityCode: string, departmentCode: string,
      observation: string, active: boolean, swExternal: boolean;

    if (!input.files[0]) {
      this.toastHandlerService.showToast(
        'error',
        'No ha seleccionado ningún archivo.'
      );
      return;
    }

    readXlsxFile(input.files[0]).then(async (rows) => {
      if (rows.length <= 1) {
        this.toastHandlerService.showToast(
          'error',
          "El archivo ingresado no tiene registros para importar."
        );
        return;
      }

      rows.splice(0, 1);
      rows.forEach(element => {
        counter = counter + 1;
        let rowHasError = false;

        //A. Código Sucursal:
        branchCode = parseFloat(element[0] as string);
        if (isNaN(branchCode)) {
          const alert = new PreInvoicingAlertModel();
          alert.alertType = 1;
          alert.message = `Fila ${counter}. El código de la sucursal no es válido.`;
          this.sellerAlerts.push(alert);
          rowHasError = true;
        }

        //B. Tipo Documento:
        const valueTypeDocumentId = element[1];
        if (valueTypeDocumentId == null || valueTypeDocumentId === "") {
          const alert = new PreInvoicingAlertModel();
          alert.alertType = 1;
          alert.message = `Fila ${counter}, Columna B. El código del tipo de documento no es válido.`;
          this.sellerAlerts.push(alert);
          rowHasError = true;
        }
        typeDocumentId = Number(valueTypeDocumentId);
        if (isNaN(typeDocumentId)) {
          const alert = new PreInvoicingAlertModel();
          alert.alertType = 1;
          alert.message = `Fila ${counter}, Columna B. El código del tipo de documento no es válido.`;
          this.sellerAlerts.push(alert);
          rowHasError = true;
        }

        //C. Documento:
        documents = element[2] as string;
        if (documents == null) {
          const alert = new PreInvoicingAlertModel();
          alert.alertType = 1;
          alert.message = `Fila ${counter}, Columna C. El número de documento es obligatorio.`;
          this.sellerAlerts.push(alert);
          rowHasError = true;
        } else if (documents.length > 15) {
          const alert = new PreInvoicingAlertModel();
          alert.alertType = 1;
          alert.message = `Fila ${counter}, Columna C. El número de documento supera el tamaño máximo de caracteres (15)`;
          this.sellerAlerts.push(alert);
          rowHasError = true;
        }

        //D. Dígito de Verificación
        const valueDigitVerification = element[3];
        if (valueDigitVerification == null || valueDigitVerification === "") {
          const alert = new PreInvoicingAlertModel();
          alert.alertType = 1;
          alert.message = `Fila ${counter}, Columna D. El dígito de verificación no es válido.`;
          this.sellerAlerts.push(alert);
          rowHasError = true;
        }
        digitVerification = Number(valueDigitVerification);
        if (isNaN(digitVerification)) {
          const alert = new PreInvoicingAlertModel();
          alert.alertType = 1;
          alert.message = `Fila ${counter}, Columna D. El dígito de verificación no es válido.`;
          this.sellerAlerts.push(alert);
          rowHasError = true;
        }

        //E. Nombre vendedor:
        name = element[4] as string;
        if (name == null) {
          const alert = new PreInvoicingAlertModel();
          alert.alertType = 1;
          alert.message = `Fila ${counter}, Columna E. El nombre del vendedor es obligatorio.`
          this.sellerAlerts.push(alert);
          rowHasError = true;
        } else if (name.length > 75) {
          const alert = new PreInvoicingAlertModel();
          alert.alertType = 1;
          alert.message = `Fila ${counter}, Columna E. El nombre del vendedor supera el tamaño máximo de caracteres (75)`;
          this.sellerAlerts.push(alert);
          rowHasError = true;
        }

        //F. Cargo:
        position = element[5] as string;
        if (position == null) {
          const alert = new PreInvoicingAlertModel();
          alert.alertType = 1;
          alert.message = `Fila ${counter}, Columna F. El cargo es obligatorio.`
          this.sellerAlerts.push(alert);
          rowHasError = true;
        } else if (position.length > 75) {
          const alert = new PreInvoicingAlertModel();
          alert.alertType = 1;
          alert.message = `Fila ${counter}, Columna F. El cargo supera el tamaño máximo de caracteres (75)`;
          this.sellerAlerts.push(alert);
          rowHasError = true;
        }

        //G. Número Teléfono:
        phone = element[6] as string;
        if (phone == null) {
          const alert = new PreInvoicingAlertModel();
          alert.alertType = 1;
          alert.message = `Fila ${counter}, Columna G. El número de teléfono es obligatorio`;
          this.sellerAlerts.push(alert);
          rowHasError = true;
        } else if (phone.length > 15) {
          const alert = new PreInvoicingAlertModel();
          alert.alertType = 1;
          alert.message = `Fila ${counter}, Columna G. El número de teléfono supera el tamaño máximo de caracteres (15)`;
          this.sellerAlerts.push(alert);
          rowHasError = true;
        }

        //H. Segundo Número Telefono:
        alterPhone = element[7] as string;
        if (alterPhone != null) {
          if (alterPhone.length > 15) {
            const alert = new PreInvoicingAlertModel();
            alert.alertType = 1;
            alert.message = `Fila ${counter}, Columna H. El número de teléfono alterno supera el tamaño máximo de caracteres (15)`;
            this.sellerAlerts.push(alert);
            rowHasError = true;
          }
        }

        //I. correo electrónico:
        email = element[8] as string;
        if (email != null) {
          if (email.length > 75) {
            const alert = new PreInvoicingAlertModel();
            alert.alertType = 1;
            alert.message = `Fila ${counter}, Columna I. El correo electrónico supera el tamaño máximo de caracteres (75)`;
            this.sellerAlerts.push(alert);
            rowHasError = true;
          }
        }

        //J. Dirección:
        address = element[9] as string;
        if (address != null) {
          if (address.length > 70) {
            const alert = new PreInvoicingAlertModel();
            alert.alertType = 1;
            alert.message = `Fila ${counter}, Columna I. La dirección supera el tamaño máximo de caracteres (70)`;
            this.sellerAlerts.push(alert);
            rowHasError = true;
          }
        }

        //K. Ciudad:
        cityCode = element[10] as string;
        if (cityCode != null) {
          if (cityCode.length > 30) {
            const alert = new PreInvoicingAlertModel();
            alert.alertType = 1;
            alert.message = `Fila ${counter}, Columna G. El código de la ciudad supera el tamaño máximo de caracteres (30)`;
            this.sellerAlerts.push(alert);
            rowHasError = true;
          }
        }

        //L. Departamento:
        departmentCode = element[11] as string;
        if (departmentCode != null) {
          if (departmentCode.length > 30) {
            const alert = new PreInvoicingAlertModel();
            alert.alertType = 1;
            alert.message = `Fila ${counter}, Columna H. El código del departamento supera el tamaño máximo de caracteres (30)`;
            this.sellerAlerts.push(alert);
            rowHasError = true;
          }
        }

        //M. observación:
        observation = element[12] as string;
        if (observation != null) {
          if (observation.length > 250) {
            const alert = new PreInvoicingAlertModel();
            alert.alertType = 1;
            alert.message = `Fila ${counter}, Columna H. La observación supera el tamaño máximo de caracteres (250)`;
            this.sellerAlerts.push(alert);
            rowHasError = true;
          }
        }

        //N. Activo:
        if (element[13] as string != "S" && element[13] as string != "N") {
          const alert = new PreInvoicingAlertModel();
          alert.alertType = 1;
          alert.message = `Fila ${counter}. El campo activo debe tener valores S o N.`;
          this.sellerAlerts.push(alert);
          rowHasError = true;
        }
        active = element[13] as string === "S" ? true : false

        //O. Sw Externo:
        if (element[14] as string != "S" && element[14] as string != "N") {
          const alert = new PreInvoicingAlertModel();
          alert.alertType = 1;
          alert.message = `Fila ${counter}. El campo sw externo debe tener valores S o N.`;
          this.sellerAlerts.push(alert);
          rowHasError = true;
        }
        swExternal = element[14] as string === "S" ? true : false

        if (!rowHasError) {
          row = new SellerImportModel(counter, branchCode, typeDocumentId, documents, digitVerification, name, position, phone, alterPhone,
            email, address, cityCode, departmentCode, observation, active, swExternal);
          rowsImports.push(row);
        } else {
          isOk = false;
        }
      });

      if (!isOk || rowsImports.length === 0) {
        this.errorSeller = 1;
        this.visibleTxt = true;
        this.toastHandlerService.showToast(
          'error',
          'La importación terminó con errores, puede exportarlos si lo desea'
        );
        return;
      }

      await this.processImportSellers(rowsImports);
    });
  }

  async processImportSellers(rowsImports: Array<SellerImportModel>) {
    try {
      const response = await firstValueFrom(this.sellerService.importSellers(rowsImports));
      this.loadPreInvoicingModel = response;
      this.sellerAlerts = response?.alerts ?? [];
      this.errorSeller = response?.preInvoicingStateId;

      if (this.errorSeller === 1) {
        this.visibleTxt = true;
        this.toastHandlerService.showToast(
          'error',
          'La importación terminó con errores, puede exportarlos si lo desea.',
          'ERROR'
        );
      } else if (this.sellerAlerts.length > 0) {
        this.visibleTxt = true;
        this.toastHandlerService.showToast(
          'error',
          'La importación terminó con alertas, puede exportarlas si lo desea'
        );
      } else {
        this.visibleTxt = false;
        this.sellerImport = true;
        this.toastHandlerService.showToast(
          'success',
          `La importación terminó exitosamente.`
        );
        this.close();
      }
      this.clearInputFile();
    } catch (error) {
      this.nameFile = 'Ningún archivo seleccionado.';
      console.error('Error al importar Vendedores.', error);
    }
  }
}
